(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-authenticity"] && !Shopify.designMode) return;
  try {
    
  /*
   * Autoplay is opt-in and motion-aware. The <video> is rendered WITHOUT an
   * autoplay attribute, so with JS off, or with prefers-reduced-motion set,
   * it simply stays on its poster with controls available.
   */
  class SsAuthenticityVideo extends HTMLElement {
    connectedCallback() {
      // The theme editor re-inserts sections, so tear down before wiring up again
      // or every re-render leaks another observer and another media listener.
      this.teardown();

      this.video = this.querySelector('video');
      if (!this.video || this.getAttribute('data-autoplay') !== 'true') return;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionQuery.matches) return;

      this.video.muted = true;
      this.selfPaused = false;
      this.userPaused = false;

      this.onMotionChange = () => {
        if (this.motionQuery.matches) this.pause();
      };
      this.onUserPause = () => {
        // A pause we did not initiate is the visitor using the controls. Honour it
        // permanently — WCAG 2.2 SC 2.2.2 requires a pause mechanism that STAYS
        // paused, and re-playing on the next scroll would take it back.
        if (!this.selfPaused) this.userPaused = true;
        this.selfPaused = false;
      };
      this.onUserPlay = () => {
        this.userPaused = false;
      };

      this.motionQuery.addEventListener('change', this.onMotionChange);
      this.video.addEventListener('pause', this.onUserPause);
      this.video.addEventListener('play', this.onUserPlay);

      if (!('IntersectionObserver' in window)) {
        this.play();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.motionQuery.matches && !this.userPaused) {
              this.play();
            } else if (!entry.isIntersecting) {
              this.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      this.teardown();
    }

    teardown() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.motionQuery && this.onMotionChange) {
        this.motionQuery.removeEventListener('change', this.onMotionChange);
      }
      if (this.video) {
        if (this.onUserPause) this.video.removeEventListener('pause', this.onUserPause);
        if (this.onUserPlay) this.video.removeEventListener('play', this.onUserPlay);
      }
    }

    pause() {
      if (!this.video || this.video.paused) return;
      this.selfPaused = true;
      this.video.pause();
    }

    play() {
      if (!this.video) return;
      const attempt = this.video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    }
  }

  if (!customElements.get('ss-authenticity-video')) {
    customElements.define('ss-authenticity-video', SsAuthenticityVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
